import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { selectors as streamSelectors } from '../../Stream';
import { getGroupsStreamId, getFolderStreamId, getGroupFolderKey } from './helpers';
import { GROUPS_PER_FETCH, GROUP_FOLDERS_PER_FETCH } from './saga';
import { reduxKey } from './constants';
export function getHasNoGroups(state) {
    const streamId = getGroupsStreamId();
    return streamSelectors.isInitialized(state, streamId) && !streamSelectors.hasMore(state, streamId) && !streamSelectors.isFetching(state, streamId) && streamSelectors.getItems(state, streamId).length === 0;
}
export function getHasOnlyOneChunkOfGroupsToLoad(state) {
    const streamId = getGroupsStreamId();
    const isFetching = streamSelectors.isFetching(state, streamId);
    if (isFetching) {
        // don't know yet
        return false;
    }
    return !streamSelectors.hasMore(state, streamId) && streamSelectors.getItems(state, streamId).length <= GROUPS_PER_FETCH;
}
export function getHasOnlyOneChunkOfGroupFoldersToLoad(state, type, groupId) {
    const streamId = getFolderStreamId(type, groupId);
    const isFetching = streamSelectors.isFetching(state, streamId);
    if (isFetching) {
        // don't know yet
        return false;
    }
    return !streamSelectors.hasMore(state, streamId) && streamSelectors.getItems(state, streamId).length <= GROUP_FOLDERS_PER_FETCH;
}
export function getGroupsStream(state) {
    const streamId = getGroupsStreamId();
    return {
        streamId,
        groups: streamSelectors.getItems(state, streamId),
        isFetching: streamSelectors.isFetching(state, streamId)
    };
}
export function getFolderStream(state, deviationId, type, groupId) {
    const streamId = getFolderStreamId(type, groupId);
    const folders = streamSelectors.getItems(state, streamId);
    return {
        streamId,
        folders: folders.map((folder)=>_object_spread({
                folder
            }, getGroupFolderState(state, deviationId, {
                groupId,
                type,
                folderId: folder.folderId
            }))),
        isFetching: streamSelectors.isFetching(state, streamId),
        hasMore: streamSelectors.hasMore(state, streamId)
    };
}
export function getGroup(state, groupId) {
    const streamId = getGroupsStreamId();
    const items = streamSelectors.getItems(state, streamId);
    if (!items) {
        return;
    }
    return items.find((group)=>group.userId === groupId);
}
export function getGroupUsername(state, groupId) {
    const group = getGroup(state, groupId);
    return group && group.username;
}
export function getGroupFolderState(state, deviationId, groupFolderId) {
    const folderKey = getGroupFolderKey(deviationId, groupFolderId);
    const folderState = state[reduxKey] && state[reduxKey][folderKey];
    return _object_spread({
        loading: false,
        added: false,
        suggested: false
    }, folderState);
}
